import { FC } from 'react';

type Props = {
    readonly className?: string;
};

export const GoogleIcon: FC<Props> = ({ className }) => (
    <svg aria-hidden="true" viewBox="0 0 24 24" className={className}>
        <path
            d="M21.805 10.023H12.24v3.955h5.486c-.236 1.273-.96 2.352-2.012 3.077v2.558h3.262c1.91-1.758 3.01-4.346 3.01-7.41 0-.727-.066-1.426-.181-2.18Z"
            fill="#4285F4"
        />
        <path
            d="M12.24 22c2.736 0 5.03-.907 6.706-2.387l-3.262-2.558c-.907.608-2.067.968-3.444.968-2.64 0-4.876-1.783-5.676-4.178H3.192v2.638A10.12 10.12 0 0 0 12.24 22Z"
            fill="#34A853"
        />
        <path
            d="M6.564 13.845a6.08 6.08 0 0 1-.317-1.925c0-.668.115-1.314.317-1.925V7.357H3.192a10.12 10.12 0 0 0 0 9.126l3.372-2.638Z"
            fill="#FBBC05"
        />
        <path
            d="M12.24 5.817c1.488 0 2.823.512 3.873 1.518l2.908-2.908C17.266 2.79 14.972 1.84 12.24 1.84A10.12 10.12 0 0 0 3.192 7.357l3.372 2.638c.8-2.395 3.036-4.178 5.676-4.178Z"
            fill="#EA4335"
        />
    </svg>
);
